export enum CallCardVariant {
  DEFAULT = 'DEFAULT',
  INBOX = 'INBOX',
  LIBRARY = 'LIBRARY',
  EXTERNAL = 'EXTERNAL',
}
